import styled from '@emotion/styled';

export const PageTemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({theme}) => theme.gap.desktop.xl};
  min-height: 100vh;
  padding: ${({theme}) => theme.padding.desktop.xl};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    ${({theme: {padding}}) =>
      `padding: ${padding.desktop.lg} ${padding.desktop.md};`}
  }
`;

export const PageTemplateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xxl};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.desktop.xl};
  }
`;

export const TitleSubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;

export const PageTemplateChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};
`;
